// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__-AO1A","notes":"Notes_notes__1AWWw","note":"Notes_note__1KIoD","markdown":"Notes_markdown__XIxA3"};